// Valor em reais por extenso (pt-BR), até 999 bilhões; centavos arredondados para duas casas.
const UNIDADES = [
  '',
  'um',
  'dois',
  'três',
  'quatro',
  'cinco',
  'seis',
  'sete',
  'oito',
  'nove',
  'dez',
  'onze',
  'doze',
  'treze',
  'quatorze',
  'quinze',
  'dezesseis',
  'dezessete',
  'dezoito',
  'dezenove',
];
const DEZENAS = [
  '',
  '',
  'vinte',
  'trinta',
  'quarenta',
  'cinquenta',
  'sessenta',
  'setenta',
  'oitenta',
  'noventa',
];
const CENTENAS = [
  '',
  'cento',
  'duzentos',
  'trezentos',
  'quatrocentos',
  'quinhentos',
  'seiscentos',
  'setecentos',
  'oitocentos',
  'novecentos',
];

const ateMil = (n: number): string => {
  if (n === 100) return 'cem';
  const centena = Math.floor(n / 100);
  const resto = n % 100;
  const partes: string[] = [];
  if (centena) partes.push(CENTENAS[centena]);
  if (resto < 20) {
    if (resto) partes.push(UNIDADES[resto]);
  } else {
    const dezena = Math.floor(resto / 10);
    const unidade = resto % 10;
    partes.push(unidade ? `${DEZENAS[dezena]} e ${UNIDADES[unidade]}` : DEZENAS[dezena]);
  }
  return partes.join(' e ');
};

const ESCALAS: Array<{ singular: string; plural: string }> = [
  { singular: '', plural: '' },
  { singular: 'mil', plural: 'mil' },
  { singular: 'milhão', plural: 'milhões' },
  { singular: 'bilhão', plural: 'bilhões' },
];

// Entre grupos usa "e" quando o seguinte é menor que 100 ou centena exata ("mil e um", "mil e
// duzentos"); nos demais, só espaço ("mil duzentos e trinta").
const inteiroPorExtenso = (n: number): string => {
  if (n === 0) return 'zero';
  const grupos: number[] = [];
  let resto = n;
  while (resto > 0) {
    grupos.push(resto % 1000);
    resto = Math.floor(resto / 1000);
  }

  const partes: Array<{ texto: string; valor: number }> = [];
  for (let i = grupos.length - 1; i >= 0; i -= 1) {
    const grupo = grupos[i];
    if (grupo) {
      let texto: string;
      if (i === 0) texto = ateMil(grupo);
      else if (i === 1) texto = grupo === 1 ? 'mil' : `${ateMil(grupo)} mil`;
      else texto = `${ateMil(grupo)} ${grupo === 1 ? ESCALAS[i].singular : ESCALAS[i].plural}`;
      partes.push({ texto, valor: grupo });
    }
  }

  return partes.reduce((acc, parte, index) => {
    if (index === 0) return parte.texto;
    const ultimo = index === partes.length - 1;
    const usaE = ultimo && (parte.valor < 100 || parte.valor % 100 === 0);
    return `${acc}${usaE ? ' e ' : ' '}${parte.texto}`;
  }, '');
};

// "de reais" depois de milhão/bilhão exatos ("um milhão de reais"), "reais" nos demais.
const precisaDe = (inteiro: number) => inteiro >= 1_000_000 && inteiro % 1_000_000 === 0;

export const valorPorExtenso = (valor: number): string => {
  if (!Number.isFinite(valor) || valor < 0) return '';
  const totalCentavos = Math.round(valor * 100);
  const inteiro = Math.floor(totalCentavos / 100);
  const centavos = totalCentavos % 100;

  if (inteiro > 999_999_999_999) return '';

  const partes: string[] = [];
  if (inteiro > 0) {
    const moeda = inteiro === 1 ? 'real' : 'reais';
    partes.push(`${inteiroPorExtenso(inteiro)}${precisaDe(inteiro) ? ' de' : ''} ${moeda}`);
  }
  if (centavos > 0) {
    partes.push(`${inteiroPorExtenso(centavos)} ${centavos === 1 ? 'centavo' : 'centavos'}`);
  }
  if (partes.length === 0) return 'zero reais';
  return partes.join(' e ');
};
